import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
export function PlanillasPreview() {
  const previews = [{
    img: 'https://cdn.magicpatterns.com/uploads/ufRoj9cCN1a2u6NDT1Uecb/plantilla.html-1.webp',
    tag: '7 Planillas Pro',
    title: 'Planilla de Relevamiento de Vano',
    desc: 'Salís a medir con una sola hoja: cliente, vano, verificaciones y cristal. Firmada por el cliente.',
    tagColor: 'gold' as const
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/aNCJbTJmCYmAwgrnWCEGGo/planilla6.html-1.webp',
    tag: 'Blindaje Anti-Error',
    title: 'Tabla Maestra de Descuentos',
    desc: 'Las fórmulas exactas de corte para corrediza, batiente y mixto. Nunca más perdés un cristal.',
    tagColor: 'gold' as const
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/2yUubcaFWBnez6M5mqHK6E/MODULO-5-23.webp',
    tag: 'Módulo 5',
    title: 'Tabla Maestra de Herrajes',
    desc: 'Qué herrajes pedir para cada tipo de mampara. La llevás al proveedor y no te olvidás nada.',
    tagColor: 'neutral' as const
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/oRaK4mWPzHBsLwSehhVPkc/PACK-MAESTRO-PRO-12.webp',
    tag: 'Calculadora de Rentabilidad',
    title: 'La Fórmula del Precio Real',
    desc: 'Materiales + mano de obra + costos ocultos + ganancia mínima. El precio que tenés que cobrar, sí o sí.',
    tagColor: 'gold' as const
  }];
  return <section className="py-16 md:py-20 bg-background border-t border-white/5" aria-label="Vista previa del contenido" data-id="element-269">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-270">
        <FadeIn data-id="element-271">
          <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-272">
            <span className="inline-block bg-gold/10 text-gold border border-gold/30 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5" data-id="element-273">
              🔍 Vista real del contenido
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-274">
              MIRÁ POR DENTRO LO QUE VAS A{' '}
              <span className="text-gold" data-id="element-275">USAR MAÑANA</span>
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-276">
              No son diapositivas. Son las planillas reales que vas a imprimir y
              pegar en el taller.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-277">
          {previews.map((p, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-278">
              <article className="group bg-surface rounded-2xl border border-white/10 overflow-hidden hover:border-gold/40 transition-colors duration-300 h-full flex flex-col" data-id="element-279">
                {/* Image preview frame */}
                <div className="relative bg-surfaceLight/40 p-4 md:p-6 border-b border-white/5" data-id="element-280">
                  <div className="absolute top-4 left-4 z-10 flex items-center gap-1.5" data-id="element-281">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" data-id="element-282" />
                    <span className="w-2.5 h-2.5 rounded-full bg-yellow-400/70" data-id="element-283" />
                    <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/70" data-id="element-284" />
                  </div>
                  <div className="absolute top-4 right-4 z-10" data-id="element-285">
                    <span className={`text-[10px] md:text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-md ${p.tagColor === 'gold' ? 'bg-gold/15 text-gold border border-gold/40' : 'bg-white/5 text-gray-300 border border-white/10'}`} data-id="element-286">
                      {p.tag}
                    </span>
                  </div>
                  <div className="aspect-[3/4] sm:aspect-[4/3] overflow-hidden rounded-lg bg-white shadow-2xl shadow-black/40 ring-1 ring-black/10" data-id="element-287">
                    <img src={p.img} alt={p.title} width={800} height={1100} loading="lazy" decoding="async"
                // @ts-ignore
                fetchpriority="low" className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500 ease-out" data-id="element-288" />
                  </div>
                </div>

                {/* Caption */}
                <div className="p-5 md:p-6 flex-1 flex flex-col" data-id="element-289">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-290">
                    {p.title}
                  </h3>
                  <p className="text-gray-400 text-sm md:text-[15px] leading-relaxed" data-id="element-291">
                    {p.desc}
                  </p>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-292">
          <div className="mt-12 text-center" data-id="element-293">
            <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-surface/60 border border-white/10 rounded-full px-6 py-3 text-sm text-gray-300" data-id="element-294">
              <span className="text-gold font-bold" data-id="element-295">+220 páginas</span>
              <span className="text-white/20" data-id="element-296">·</span>
              <span className="text-gold font-bold" data-id="element-297">8 módulos</span>
              <span className="text-white/20" data-id="element-298">·</span>
              <span className="text-gold font-bold" data-id="element-299">7 planillas pro</span>
              <span className="text-white/20" data-id="element-300">·</span>
              <span data-id="element-301">Todo listo para imprimir</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}